import { Button, Container, FormGroup, Input, Label } from "reactstrap";
import { App } from "../../App";
import { Tax } from "../../../shared/api";
import { useId, useMemo, useState } from "react";

export interface EditTaxProps {
	tax?: Tax.TaxType;
	country: {
		code: string;
		label: string;
	};
	on_save: (tax: Tax.TaxType) => any;
	on_delete?: (tax: Tax.TaxType) => any;
}

export function EditTax(props: EditTaxProps) {

	let tax = useMemo<Tax.TaxType>(() => {
		if (props.tax) {
			return {...props.tax};
		} else {
			return {
				id: null,
				country: props.country.code,
				label: "",
				rate: 0,
				is_default: false,
			};
		}
	}, []);

	const [is_valid, set_is_valid] = useState(true);

	const btn_save = async () => {
		if(await props.on_save(tax)) {
			App.open(null, false);
		}
	}

	const btn_back = () => {
		App.open(null, false);
	}

	const btn_delete = async () => {
		if(props.on_delete && await props.on_delete(tax)) {
			App.open(null);
		}
	}

	const on_change = () => {
		set_is_valid(tax.label.length > 0 && isFinite(tax.rate) && tax.rate >= 0);
	}

	const id = {
		label: useId(),
		rate: useId(),
		is_default: useId(),
	};

	return (
		<Container>
			<h4>{props.tax ? "Edit" : "Add"} Tax ({props.country.label})</h4>
			<FormGroup>
				<Label htmlFor={id.label}>Name</Label>
				<Input type="text" 
					defaultValue={tax.label} 
					id={id.label} 
					onChange={e => {
						tax.label = e.target.value;
						on_change();
					}}
				/>
			</FormGroup>
			<FormGroup>
				<Label htmlFor={id.rate}>Rate (%)</Label>
				<Input type="number"
					defaultValue={(tax.rate * 100).toLocaleString()}
					id={id.rate}
					onChange={e => {
						tax.rate = parseFloat(e.target.value) / 100;
						on_change();
					}}
				/>
			</FormGroup>
			<FormGroup>
				<Input type="checkbox"
					defaultChecked={!!tax.is_default}
					id={id.is_default} 
					onChange={e => {
						tax.is_default = e.target.checked;
						on_change();
					}}
					disabled={!!props.tax?.is_default}
				/> <Label htmlFor={id.is_default}>Set as Default</Label>
			</FormGroup>
			<FormGroup>
				<Button onClick={btn_save} disabled={!is_valid}>Save</Button>
				<Button onClick={btn_back}>Back</Button>
				{props.on_delete ? (
					<Button onClick={btn_delete} color="danger" disabled={!!props.tax?.is_default} style={{float: "right"}}>Delete</Button>
				) : <></>}
			</FormGroup>
		</Container>
	);
}

